import React from 'react';
import { Section } from './ui/Section';
export function AcceleratorComparison() {
  const rows = [{
    situation: 'Quieres implementar el sistema pero no sabes por dónde empezar',
    without: 'Pierdes días leyendo sin aplicar',
    with: 'Manual de Ejecución: El sistema montado en una tarde.'
  }, {
    situation: 'Tienes muchos pensamientos pero no sabes cómo clasificarlos',
    without: 'Improvisas y abandonas',
    with: 'Plantillas Pro: Solo rellenas y vacías con la estructura lista.'
  }, {
    situation: 'Llegas a casa agotado y no tienes energía para pensar',
    without: 'El PDF se acumula sin usar',
    with: 'Formato Rellenable: Haz tu vaciado con un par de clics o trazos.'
  }, {
    situation: 'Quieres hacer el vaciado pero no tienes tiempo de diseñar el formato',
    without: 'Empiezas de cero cada vez',
    with: '12 Plantillas Listas: Diseñadas para cada tipo de ruido mental.'
  }, {
    situation: 'La semana se complica y pierdes el hábito',
    without: 'Recaes en el ciclo de saturación',
    with: 'Sistema de Reactivación: 3 pasos para volver al control en 5 min.'
  }];
  const includes = ['12 Plantillas de Vaciado Pro: PDF rellenable listo para usar (no necesitas imprimir).', 'Manual de Implementación Rápida: La hoja de ruta para montar tu sistema en 15 minutos.', 'Sistema de Reactivación Semanal: Guía paso a paso para limpiar tu sistema cada domingo.', 'Tracker de Hábitos (4 Semanas): Registro visual para asegurar que el vaciado se vuelve automático.', 'Guía de Personalización: Adapta el protocolo a tu estilo de vida (freelance, empleado o líder).', 'Kit de Notas Rápidas: Plantillas minimalistas para capturar ideas en movimiento.'];
  return <Section data-id="element-22">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-23">
        🕊️ ¿QUÉ AGREGA EL ACELERADOR 10X?
      </h2>

      <div className="overflow-x-auto mb-16 pb-4" data-id="element-24">
        <table className="w-full min-w-[800px] border-collapse" data-id="element-25">
          <thead data-id="element-26">
            <tr data-id="element-27">
              <th className="text-left p-4 border-b border-neutral-800 text-neutral-400 font-medium w-1/3" data-id="element-28">
                Situación real
              </th>
              <th className="text-left p-4 border-b border-neutral-800 text-red-400 font-medium w-1/3" data-id="element-29">
                ❌ Sin el Acelerador
              </th>
              <th className="text-left p-4 border-b border-neutral-800 text-green-400 font-medium w-1/3" data-id="element-30">
                ✅ Con el Acelerador
              </th>
            </tr>
          </thead>
          <tbody data-id="element-31">
            {rows.map((row, i) => <tr key={i} className="hover:bg-brand-card/50 transition-colors" data-id="element-32">
                <td className="p-4 border-b border-neutral-800/50 text-neutral-300" data-id="element-33">
                  {row.situation}
                </td>
                <td className="p-4 border-b border-neutral-800/50 text-neutral-500" data-id="element-34">
                  {row.without}
                </td>
                <td className="p-4 border-b border-neutral-800/50 text-white font-medium" data-id="element-35">
                  {row.with}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="bg-brand-card border border-brand-accent/30 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-36">
        <h3 className="text-xl font-bold text-brand-accent mb-6" data-id="element-37">
          ✅ EL ACELERADOR INCLUYE:
        </h3>
        <div className="grid md:grid-cols-2 gap-4" data-id="element-38">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-39">
              <span className="text-brand-accent mt-1 shrink-0" data-id="element-40">⚡</span>
              <span className="text-neutral-200" data-id="element-41">{item}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}